export const PrivacyEnum = [
    { id: 'public', name: 'Public' },
    { id: 'private', name: 'Private' }
];

